var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nk-app-root sip-shell sip-shell--clean" }, [
    _c(
      "div",
      { staticClass: "nk-main sip-shell__grid" },
      [
        _c("div", {
          staticClass: "sip-nav-overlay",
          class: { "is-open": _vm.sidebarOpen },
          on: { click: _vm.closeSidebar },
        }),
        _vm._v(" "),
        _c("app-sidebar", {
          attrs: {
            "is-open": _vm.sidebarOpen,
            "nav-items": _vm.visibleMenu,
            "nav-metrics": _vm.navMetrics,
            "logo-url": _vm.headerLogoUrl,
            "instance-stats": _vm.instance_stats,
          },
          on: { "close-sidebar": _vm.closeSidebar },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "nk-wrap sip-workspace" }, [
          _c("header", { staticClass: "sip-topbar" }, [
            _c(
              "div",
              { staticClass: "container-fluid sip-topbar__container" },
              [
                _c(
                  "div",
                  { staticClass: "sip-topbar__row sip-topbar__row--primary" },
                  [
                    _c(
                      "div",
                      { staticClass: "sip-topbar__brand-wrap d-xl-none" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "sip-topbar__menu-btn",
                            attrs: {
                              href: "#",
                              role: "button",
                              "aria-controls": "MainSideBarRightMenu",
                              "aria-expanded": _vm.sidebarOpen
                                ? "true"
                                : "false",
                              "aria-label": "Open menu",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.openSidebar.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._m(0)]
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "sip-topbar__brand",
                            attrs: { to: "/" },
                          },
                          [
                            _c("span", { staticClass: "sip-topbar__mark" }, [
                              _vm.headerLogoUrl && !_vm.headerLogoError
                                ? _c("img", {
                                    attrs: { src: _vm.headerLogoUrl, alt: "" },
                                    on: {
                                      error: function ($event) {
                                        _vm.headerLogoError = true
                                      },
                                    },
                                  })
                                : _c("span", [_vm._v("S")]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "sip-topbar__brand-copy" },
                              [_c("strong", [_vm._v("Sipinor")])]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sip-topbar__search" },
                      [_c("admin-global-search")],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sip-topbar__actions" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "sip-topbar__icon-btn",
                            attrs: {
                              type: "button",
                              title: _vm.isDarkMode
                                ? "Light mode"
                                : "Dark mode",
                              "aria-label": _vm.isDarkMode
                                ? "Light mode"
                                : "Dark mode",
                            },
                            on: { click: _vm.toggleDarkMode },
                          },
                          [
                            _c("admin-icon", {
                              attrs: {
                                name: _vm.isDarkMode ? "sun" : "moon",
                                "aria-hidden": "true",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.hasPermission("list-query")
                          ? _c(
                              "router-link",
                              {
                                staticClass: "sip-topbar__icon-btn",
                                attrs: {
                                  to: "/query",
                                  title: "Queries",
                                  "aria-label": "Queries",
                                },
                              },
                              [
                                _c("admin-icon", {
                                  attrs: {
                                    name: "bell",
                                    "aria-hidden": "true",
                                  },
                                }),
                                _vm._v(" "),
                                _vm.query_stats.total
                                  ? _c(
                                      "small",
                                      { staticClass: "sip-topbar__badge" },
                                      [_vm._v(_vm._s(_vm.query_stats.total))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dropdown user-dropdown sip-topbar__user",
                          },
                          [
                            _c(
                              "a",
                              {
                                ref: "profileMenuButton",
                                staticClass:
                                  "sip-topbar__user-btn dropdown-toggle",
                                attrs: {
                                  href: "#",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-label": "Open profile menu",
                                },
                                on: {
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "down",
                                        40,
                                        $event.key,
                                        ["Down", "ArrowDown"]
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.focusFirstProfileItem.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "sip-topbar__avatar" },
                                  [_vm._v(_vm._s(_vm.headerInitial))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "sip-topbar__user-meta d-none d-md-inline",
                                  },
                                  [_vm._v(_vm._s(_vm.headerFirstName))]
                                ),
                                _vm._v(" "),
                                _c("admin-icon", {
                                  staticClass:
                                    "sip-topbar__caret d-none d-md-inline",
                                  attrs: {
                                    name: "chevron-down",
                                    "aria-hidden": "true",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-end user-dropdown-menu sip-dropdown",
                                attrs: { role: "menu" },
                                on: {
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    )
                                      return null
                                    $event.preventDefault()
                                    return _vm.closeProfileMenu.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [
                                _c("div", { staticClass: "dropdown-inner" }, [
                                  _c(
                                    "div",
                                    { staticClass: "sip-dropdown__head" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "sip-dropdown__avatar",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [_vm._v(_vm._s(_vm.headerInitial))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "sip-dropdown__copy" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "sip-dropdown__name",
                                            },
                                            [_vm._v(_vm._s(_vm.headerFullName))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "sip-dropdown__email",
                                            },
                                            [_vm._v(_vm._s(_vm.headerEmail))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "link-list link-list-opt no-bdr sip-dropdown__menu",
                                    },
                                    [
                                      _c(
                                        "li",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: "/profile",
                                                role: "menuitem",
                                              },
                                            },
                                            [
                                              _c("admin-icon", {
                                                attrs: { name: "user" },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans("user.profile")
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: "/change-password",
                                                role: "menuitem",
                                              },
                                            },
                                            [
                                              _c("admin-icon", {
                                                attrs: { name: "lock" },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans(
                                                      "user.change_password"
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        { staticClass: "sip-dropdown__logout" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "#",
                                                role: "menuitem",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.logout.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("admin-icon", {
                                                attrs: { name: "logout" },
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.trans("auth.logout")
                                                  )
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "main",
            { staticClass: "nk-content nk-content-fluid sip-page-shell" },
            [
              _c(
                "div",
                { staticClass: "container-fluid sip-page-shell__container" },
                [
                  _c(
                    "div",
                    { staticClass: "nk-content-body" },
                    [_c("router-view", { key: _vm.$route.fullPath })],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("footer", { staticClass: "nk-footer sip-footer" }, [
            _c("div", { staticClass: "container-fluid" }, [
              _c(
                "div",
                { staticClass: "nk-footer-wrap" },
                [_c("app-footer")],
                1
              ),
            ]),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "sip-mobile-menu", attrs: { "aria-hidden": "true" } },
      [_c("span"), _vm._v(" "), _c("span")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }